import { ShieldCheck, Award, Star, BadgeCheck, Landmark, CalendarClock } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, title: "Licensed & Insured", sub: "CA License #950130" },
  { icon: Award, title: "Polyglass Certified", sub: "Approved Applicator" },
  { icon: Award, title: "CertainTeed Certified", sub: "ShingleMaster" },
  { icon: Award, title: "Owens Corning", sub: "Certified Roofer" },
  { icon: BadgeCheck, title: "BBB Accredited", sub: "A+ Reputation" },
  { icon: Star, title: "5.0 Google Rating", sub: "127+ Reviews" },
  { icon: Landmark, title: "Financing Available", sub: "Up to $250K" },
  { icon: CalendarClock, title: "Since 1980", sub: "46+ Years" },
];

export const TrustBadges = () => {
  return (
    <section data-testid="trust-badges-section" className="py-14 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-center text-sm uppercase tracking-[0.2em] font-bold text-slate-400 mb-8">
          Trusted, Certified, Proven
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4">
          {BADGES.map((b) => (
            <div
              key={b.title}
              data-testid={`badge-${b.title.replace(/\s+/g, "-").toLowerCase()}`}
              className="flex flex-col items-center text-center gap-2 rounded-xl border border-slate-200 bg-slate-50 p-4 hover:border-red-200 hover:bg-red-50/40 transition-colors"
            >
              <div className="grid place-items-center h-11 w-11 rounded-full bg-slate-900 text-red-600">
                <b.icon className="h-6 w-6" />
              </div>
              <div>
                <div className="font-display font-bold text-sm text-slate-900 leading-tight">{b.title}</div>
                <div className="text-xs text-slate-500">{b.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
